import React from 'react';

class Input extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            focus: false,
            error: false,
            value: ''
        };
    }

    handleFocus() {
        this.setState({
            focus: true
        })
    }

    handleBlur(event) {
        this.setState({
            focus: false
        })
        if (this.props.onBlur) {
            this.props.onBlur(event)
        }
    }

    handleChange(event) {
        const { name, value } = event.target
        this.setState({
            value: event.target.value
        })
        if (this.props.onChange) {
            this.props.onChange(event, name, value)
        }
    }

    handleClick(event) {
        this.props.onButtonClick(event)
    }

    handleErrorClick(e) {
        this.setState({
            error: false
        })
    }

    componentWillMount() {
        if (this.props.value) {
            this.setState({
                focus: true,
                value: this.props.value
            })
        }
        if (this.props.error) {
            this.setState({
                error: true
            })
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.value !== this.props.value) {
            const focus = nextProps.value ? true : false
            // const error = nextProps.error ? true : false
            this.setState({
                focus: focus,
                // error: error,
                value: nextProps.value
            })
        }
        if (nextProps.error && nextProps.error !== this.props.error) {
            this.setState({
                error: true
            })
        }
    }

    render () {
        
        const noMargin = this.props.no_margin || this.props.noMargin ? 'no-margin' : ''

        const className = this.state.focus || this.state.value ? 'input-filled' : ''
        const focused = this.state.focus ? 'input-focus' : ''
        const autoComplete = this.props.autocomplete === 'off' ? 'off' : 'on'
        // const maxlength = this.props.maxlength ? `maxlength="${this.props.maxlength}"` : ''

        const button = this.props.button ? <button type="button" className="input-button" onClick={this.handleClick.bind(this)}>{this.props.button}</button> : ''
        const displayError = this.state.error ? 'display' : ''
        const errorBlur = this.state.error ? 'blur' : ''

        return (
            <div className={ `input-container ${className} ${focused} ${noMargin} ${ this.props.className ? this.props.className : '' }` }>
                <label className={errorBlur} htmlFor={ `for_${this.props.name}` }>
                    <span className="label">
                        {this.props.label}
                        <span className="input-helper">{this.props.helper}</span>
                    </span>
                    <input className={errorBlur} type={this.props.type} ref={this.props.name} name={this.props.name} id={ `for_${this.props.name}` } autoComplete={autoComplete} onFocus={this.handleFocus.bind(this)} onBlur={this.handleBlur.bind(this)} onChange={this.handleChange.bind(this)} value={this.state.value} />
                    {button}
                    <div className={`input-error ${displayError}`} onClick={this.handleErrorClick.bind(this)}>
                        <span>{this.props.error}</span>
                    </div>
                </label>
            </div>
        );
    }
}

export default Input;


// WEBPACK FOOTER //
// ./src/components/Form/Input.js